import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/orders/assortment-current",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "046"
  ],
  "cita": "Areas/CEDIS/Controllers/OrdersController.cs"
} satisfies RutaProd;
